import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHelperDataService } from '../../shared/services/http-helper-data.service';
import { Configuration } from '../../app.configuration.service';
import { SecurityService } from '../../shared/services/security.service';
import { TipoIntervencao } from '../../model/referenceData/tipoIntervencao';
import { Observable } from 'rxjs/internal/Observable';
import { ArtigoFamilia } from '../../model/referenceData/artigoFamilia';
import { Oficina } from '../../model/referenceData/oficina';
import { AutorizacaoEstado } from 'src/app/model/referenceData/autorizacaoEstado';

@Injectable()
export class ReferenceDataService {

  constructor(
    protected http: HttpClient, protected httpHelper: HttpHelperDataService,
    protected configuration: Configuration, protected securityService: SecurityService) {

    httpHelper.controllerName = 'v1/ReferenceData';
  }

  public getAutorizacaoEstado = (): Observable<AutorizacaoEstado> => {
    return this.httpHelper.httpGet('AutorizacaoEstado');
  }

  public getTipoIntervencao = (): Observable<TipoIntervencao> => {
    return this.httpHelper.httpGet('TipoIntervencao');
  }

  public getArtigoFamilia = (): Observable<ArtigoFamilia> => {
    return this.httpHelper.httpGet('ArtigoFamilia');
  }

  public getOficina = (): Observable<Oficina> => {
    return this.httpHelper.httpGet('Oficina');
  }
}
